import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { filter, map, startWith } from 'rxjs';

import { EventService } from '~console/app/~shared/services/event.service';
import { GlobalEvent, StepInfo } from '~core/models/shared.models';

@Component({
  selector: 'onboarding-layout',
  standalone: false,
  templateUrl: './onboarding-layout.component.html',
  styleUrl: './onboarding-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingLayoutComponent {
  private readonly _eventService = inject(EventService);

  readonly stepInfos: StepInfo[] = [
    {
      title: 'Adresse du siège et coordonnées',
      description:
        "Ajoutez l'adresse complète et les informations de contact de votre siège. Elles serviront à identifier votre entreprise et à générer son premier établissement et point de vente."
    },
    {
      title: 'Déclaration de vos équipements de facturation',
      description:
        'Indiquez si votre entreprise utilise des équipements de facturation ou une caisse enregistreuse. Ces informations nous aident à configurer correctement vos modalités de facturation dans le système.'
    },
    {
      title: 'Résumé de vos informations',
      description:
        "Voici le récapitulatif complet des informations de votre entreprise. Prenez un instant pour confirmer ou corriger avant de finaliser l'inscription."
    }
  ];

  currentStepInfo$ = this._eventService.events$.pipe(
    filter((event: GlobalEvent) => event.type === 'ONBOARDING_STEP_CHANGED'),
    map(
      (event: GlobalEvent) =>
        this.stepInfos[event.value as number] || this.stepInfos[0]
    ),
    startWith(this.stepInfos[0])
  );
}
